export const widgetsConstants = {
    WIDGETS_FETCH_REQUEST: 'WIDGETS_FETCH_REQUEST',
    WIDGETS_FETCH_SUCCESS: 'WIDGETS_FETCH_SUCCESS',
    WIDGETS_FETCH_FAILURE: 'WIDGETS_FETCH_FAILURE', 
 };